type Cookies = { [k: string]: string } | null;

function parseServerCookies(req: Request) {
  const cookieString = req.headers.get("cookie");
  if (!cookieString) return null;

  return Object.fromEntries(
    cookieString.split(";").map((c) => {
      const [key, ...val] = c.trim().split("=");
      return [key, decodeURIComponent(val.join("="))];
    }),
  );
}

function setCookie(
  name: string,
  value: string,
  days?: number,
  path: string = "/",
) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = `${name}=${encodeURIComponent(
    value,
  )}${expires}; path=${path}`;
}

function getCookie(name: string) {
  const nameEQ = name + "=";
  const cookies = document.cookie.split("; ");
  for (const c of cookies) {
    if (c.indexOf(nameEQ) === 0) {
      return decodeURIComponent(c.substring(nameEQ.length));
    }
  }
  return null;
}

function deleteCookie(name: string, path: string = "/") {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}`;
}

const clientCookie = {
  get: getCookie,
  set: setCookie,
  delete: deleteCookie,
};

export { clientCookie, type Cookies, parseServerCookies };
